import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ExternalLink } from "~/components/site/external-link";
import type { Author } from "~/lib/authors";

type Props = Readonly<{
  authors: readonly Author[];
}>;

export function Contributors({ authors }: Props): JSX.Element {
  return (
    <>
      <h3 className="text-xl mt-12 mb-6">Contributors</h3>
      <ul className="grid sm:grid-cols-2 gap-4 md:gap-6 mb-12 m-0 p-0">
        {authors.map((a) => (
          <li className="flex items-center gap-x-6 m-0" key={a.name}>
            <img
              alt={`${a.name} | Brale`}
              className="w-24 h-24 rounded-full"
              src={`${a.avatar}`}
            />
            <div className="flex flex-col">
              <div className="eyebrow text-primary !mb-0">{a.name}</div>
              <span className="text-base">{a.jobTitle}</span>
              <div className="flex gap-x-3">
                {a.social.twitter && (
                  <ExternalLink
                    aria-label={`${a.name} on Twitter`}
                    href={a.social.twitter}
                    className="leading-none mt-2"
                  >
                    <FontAwesomeIcon
                      className="h-5 w-5 text-gray-500"
                      icon={faXTwitter}
                    />
                  </ExternalLink>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
}
